import React from 'react';
import moment from 'moment'
import { DATE_FORMAT } from '../../../constants';

export const MASTER_SECTION_TYPE = ['FINANCIAL', 'OBJECT_LIST', 'SIMPLE'];
export const MASTER_TYPE = ['NUMERIC', 'ALPHANUMERIC'];
export const DEFAULT_CHECKBOX_VALUES = [
    {
        label: 'FINANCIAL',
        value: false,
        type: 'keyType'
    }, {
        label: 'OBJECT_LIST',
        value: false,
        type: 'keyType'
    },
    {
        label: 'SIMPLE',
        value: false,
        type: 'keyType'
    },
    {
        label: 'VERTICAL_LIST',
        value: false,
        type: 'dataType'
    },
    {
        label: 'NUMERIC',
        value: false,
        type: 'dataType'
    },
    {
        label: 'ALPHANUMERIC',
        value: false,
        type: 'dataType'
    }
]
export const TABLE_COLUMNS = [
    {
        Header: 'Name',
        id: 'name',
        accessor: p => <div>{p.name}</div>,
        maxWidth: 300
    },
    {
        Header: 'Data Type',
        accessor: 'dataType',
    },
    {
        Header: 'Key Type',
        accessor: 'keyType',
    },
    {
        Header: 'Created On',
        id: 'createdAt',
        accessor: p => <div title={p.createdAt}>{moment(p.createdAt).format(DATE_FORMAT)}</div>,
        sortMethod: (a, b) => {
            a = new Date(a.props.title).getTime();
            b = new Date(b.props.title).getTime();
            if (b > a) return 1;
            else if (b < a) return -1;
            else if (b === a) return 0;
        }
    }
];

export const DEFAULT_SORTING = {
    id: 'name',
    desc: true
}
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 0;
export const DEFAULT_REQUEST_BODY = {
    paginatedData: {
        pageNumber: DEFAULT_PAGE_NUMBER,
        pageSize: DEFAULT_PAGE_SIZE,
        sortfield: 'name',
        sortDirection: 'desc'
    },
    requestData: {
        name: '',
        keyTypes: [],
        dataTypes: []
    }
}
export const ENTER = 'Enter';